import { webStorage } from "../utils/webStorage";
import { canUseDOM } from "../utils";

export const restoreData = (key, defaultValue = null) => {
  return canUseDOM() ? webStorage.get(key) || defaultValue : null;
};
